//
// Copyright (c) 2011-2019 by Curalate, Inc.
//

import { createSelector } from 'reselect';

import { ICuralateStore } from '@models/AppState';
import { IUnisonDateRange } from '@models/UnisonTypes';
import DateString from '@models/DateString';

export const getSessionDateRange = createSelector(
  (state: ICuralateStore) => state.session,
  ({ dateRange }): IUnisonDateRange => {
    const startDate = new Date(dateRange.from);
    const endDate = new Date(dateRange.to);

    return {
      startDate,
      endDate,
      alias: 'custom',
    };
  },
);

const SESSION_DATE_RANGE_FORMAT = 'MM/DD/YYYY';

/**
 * The date range in the session is represented by strings in the format MM/DD/YYYY,
 * so to use them as DateStrings we have to reformat them.
 */
export const getSessionDateRangeAsDateStrings = createSelector(
  (state: ICuralateStore) => state.session.dateRange,
  (dateRange) => {
    const { from, to } = dateRange;
    return {
      startDate: DateString.fromString(from, SESSION_DATE_RANGE_FORMAT),
      endDate: DateString.fromString(to, SESSION_DATE_RANGE_FORMAT),
    };
  },
);
